import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { OfferEffects, offerReducer } from './store';

@NgModule({
  imports: [EffectsModule.forFeature([OfferEffects]), StoreModule.forFeature(`offer`, offerReducer)]
})
export class OfferStateModule {}
